// Team member session helpers (2026-10-31).
// A team login stores the member's permissions (see backend
// utils/teamPermissions.js); the team header refreshes them from /team/me so
// the owner's changes apply without a new login. The backend enforces every
// permission — this only hides buttons the member can't use.
import myAxios from '../AxiosUrl';

const KEY = 'teamPerms';
const SCOPE = 'teamScope';

export const isTeamSession = () => !!localStorage.getItem('teamid');

export function saveTeamAccess(permissions, orderScope) {
    try {
        localStorage.setItem(KEY, JSON.stringify(Array.isArray(permissions) ? permissions : []));
        localStorage.setItem(SCOPE, orderScope === 'assigned' ? 'assigned' : 'all');
    } catch (e) {
        /* storage blocked */
    }
}

export function clearTeamSession() {
    ['teamid', 'Admin_Id', KEY, SCOPE].forEach((k) => localStorage.removeItem(k));
}

/** true for sellers; for team members only when they have the permission. */
export function teamCan(permission) {
    if (!isTeamSession()) return true;
    try {
        const list = JSON.parse(localStorage.getItem(KEY) || 'null');
        // a session from before permissions existed: all (the backend still checks)
        return Array.isArray(list) ? list.includes(permission) : true;
    } catch (e) {
        return true;
    }
}

export function refreshTeamAccess() {
    if (!isTeamSession()) return Promise.resolve(null);
    return myAxios
        .get('/team/me')
        .then((res) => {
            saveTeamAccess(res.data?.permissions, res.data?.orderScope);
            return res.data;
        })
        .catch(() => null);
}
